import { FC, PropsWithChildren } from "react";

import { AuthProvider } from "@hl/shared-features/lib/features/auth";
import { AppBootstrap } from "@hl/shared-features/lib/features/auth/AppBootstrap";
import { SwapModalProvider } from "@hl/shared-features/lib/features/balance/SwapModalContext";
import TransactionProvider from "@hl/shared-features/lib/features/evm-tx/TransactionProvider";
import MarketplaceProvider from "@hl/shared-features/lib/features/marketplace/provider";
import { ModalStack } from "@hl/shared-features/lib/features/modal";
import { WatchlistAndFollowContextProvider } from "@hl/shared-features/lib/features/watchlist-and-follow/WatchlistAndFollowContext";

export const AppProviders: FC<
  PropsWithChildren<{ mode: "privy" | "farcaster" }>
> = ({ mode, children }) => {
  return (
    <AuthProvider mode={mode}>
      <AppBootstrap>
        <TransactionProvider>
          <SwapModalProvider>
            <MarketplaceProvider>
              <WatchlistAndFollowContextProvider>
                <ModalStack>{children}</ModalStack>
              </WatchlistAndFollowContextProvider>
            </MarketplaceProvider>
          </SwapModalProvider>
        </TransactionProvider>
      </AppBootstrap>
    </AuthProvider>
  );
};
